import {
  EnvironmentFeatureFlagStateDto,
  FeatureFlagEnvironmentDetailDto,
  VariantDto,
} from '@flagsync/skyline';

export const useTargetedVariants = (
  ffes: EnvironmentFeatureFlagStateDto,
): VariantDto[] => {
  const {
    featureFlag,
    isEnabled,
    targetedVariantIds,
    enabledSingleVariantId,
    disabledSingleVariantId,
  } = ffes;

  const defaultVariant = featureFlag.variants.find((v) => {
    return isEnabled
      ? v.variantId === enabledSingleVariantId
      : v.variantId === disabledSingleVariantId;
  });

  /**
   * Build a map of all targeting variants
   */
  const map = new Map();

  if (defaultVariant) {
    map.set(defaultVariant.variantId, defaultVariant);
  }

  if (isEnabled) {
    const variantIds = targetedVariantIds as unknown as number[];
    featureFlag.variants.forEach((v) => {
      if (variantIds.includes(v.variantId)) {
        map.set(v.variantId, v);
      }
    });
  }

  return Array.from(map.values()).sort((a, b) => a.variantId - b.variantId);
};

type VariantDtoWithIndex = VariantDto & { index: number };

export const useTargetedVariantsForFlagEnvironmentDetail = (
  ffes: FeatureFlagEnvironmentDetailDto,
): VariantDtoWithIndex[] => {
  const { featureFlag, state } = ffes;

  const set = new Set();

  const defaultServing = featureFlag.variants.find(
    (v) =>
      v.variantId ===
      (state.isEnabled
        ? state.enabledSingleVariantId
        : state.disabledSingleVariantId),
  );

  if (defaultServing) {
    set.add(defaultServing.variantId);
  }

  if (state.isEnabled) {
    state.targetingRules.forEach((rule) => {
      set.add(rule.variantId);
    });
    state.percentageRollout.forEach((rule) => {
      if (rule.percentage > 0) {
        set.add(rule.variantId);
      }
    });
  }

  const targetedVariantIds = Array.from(set);
  const variants = featureFlag.variants.filter((v) =>
    targetedVariantIds.includes(v.variantId),
  );

  return variants
    .map((v) => {
      const index = featureFlag.variants.findIndex(
        (variant) => variant.variantId === v?.variantId,
      );
      return { ...v, index };
    })
    .sort((a, b) => a.variantId - b.variantId);
};
